import React, { useState, useEffect } from 'react';
import { css } from 'emotion';
import { Input, MaxModal } from '@maxmilhas/hangar-components-atomic/public';
import { uuidv4 } from '../../../../shared/utils';
import RawHtml from '../RawHtml';
import * as cs from './style';

export const AcceptanceTerms = ({ children, label, title, modalTitle, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [labelTerms, setLabelTerms] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const firstLabels = label.split('<a>');
    const secondLabels = firstLabels[1].split('</a>');
    setLabelTerms([firstLabels[0], secondLabels[0], secondLabels[1]]);
  }, []);

  const handleChecked = event => {
    setChecked(event.target.checked);
    onChange(event);
  };

  return (
    <div className={css`${cs.acceptanceTerms}`}>
      <p className="title">
        {title}
      </p>

      <div className="checkbox">
        <Input type="checkbox" id={uuidv4()} label=" " checked={checked} onChange={handleChecked} />
        {labelTerms && (
          <p>{labelTerms[0]}<a onClick={() => setIsOpen(true)}>{labelTerms[1]}</a>{labelTerms[2]}</p>
        )}
      </div>

      <MaxModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        style={{ modal: { zIndex: 99999 } }}
      >
        <div className={css`${cs.acceptanceTermsModal}`}>
          <h2>{modalTitle || 'Termo de acordo'}</h2>
          {children && <RawHtml>{children.replace(/\u21B5/g,'<br/>')}</RawHtml>}
        </div>
      </MaxModal>
    </div>
  )
};

export default AcceptanceTerms;